"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UITabs = _interopRequireDefault(require("UIComponents/nav/UITabs"));

var _UITab = _interopRequireDefault(require("UIComponents/nav/UITab"));

var _UIToolBar = _interopRequireDefault(require("UIComponents/nav/UIToolBar"));

var _UIToolBarGroup = _interopRequireDefault(require("UIComponents/nav/UIToolBarGroup"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIBadge = _interopRequireDefault(require("UIComponents/badge/UIBadge"));

var _DynoEditor = require("lead-flows-ui/constants/DynoEditor");

var EDITOR_STEPS = Object.values(_DynoEditor.STEPS || {});

var TabsNavigationBar =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TabsNavigationBar, _PureComponent);
  (0, _createClass2.default)(TabsNavigationBar, null, [{
    key: "propTypes",
    get: function get() {
      return {
        currentStep: _react.default.PropTypes.oneOf(EDITOR_STEPS).isRequired,
        gates: _react.default.PropTypes.object.isRequired,
        handleChangeStep: _react.default.PropTypes.func.isRequired,
        validation: _react.default.PropTypes.object,
        isPopupFormless: _react.default.PropTypes.bool
      };
    }
  }]);

  function TabsNavigationBar(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TabsNavigationBar);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TabsNavigationBar).call(this, props));
    _this.handleStepChange = _this.handleStepChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TabsNavigationBar, [{
    key: "handleStepChange",
    value: function handleStepChange(_ref) {
      var value = _ref.target;
      this.props.handleChangeStep(value.value);
    }
  }, {
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor.secondaryNavigation." + suffix;
    }
  }, {
    key: "getTabs",
    value: function getTabs() {
      var gates = this.props.gates;

      if (!gates['LeadFlows:AudienceTargeting']) {
        var steps = (0, _toConsumableArray2.default)(EDITOR_STEPS);
        steps.splice(EDITOR_STEPS.indexOf(_DynoEditor.STEPS.TARGETING), 1);
        return steps;
      } else {
        return EDITOR_STEPS;
      }
    }
  }, {
    key: "renderTabs",
    value: function renderTabs() {
      var _this2 = this;

      return this.getTabs().map(function (step) {
        return _react.default.createElement(_UITab.default, {
          className: step + "-tab",
          key: step,
          tabId: step,
          disabled: /^(thanks|form|follow-up)$/.test(step) && _this2.props.isPopupFormless,
          title: _react.default.createElement("div", null, _this2.renderValidationHelper(step))
        });
      });
    }
  }, {
    key: "renderValidationHelper",
    value: function renderValidationHelper(step) {
      var messages = this.props.validation[step];
      var messagesArray = messages && Object.keys(messages).filter(function (message) {
        return message !== 'name';
      });

      if (messagesArray && messagesArray.length) {
        var messagesContent = messagesArray.map(function (key) {
          var errorIndex;

          if (step === 'follow-up') {
            errorIndex = parseInt(key.split('_')[1], 10) + 1;
          }

          return _react.default.createElement("li", {
            key: key
          }, _react.default.createElement(_FormattedMessage.default, {
            message: messages[key],
            options: {
              errorIndex: errorIndex
            }
          }));
        });

        var messagesList = _react.default.createElement("div", {
          className: "secondary-navigation__validation-content"
        }, _react.default.createElement("ul", null, messagesContent));

        return _react.default.createElement("span", null, _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey("steps." + step)
        }), ' ', step === 'targeting' ? _react.default.createElement(_UIBadge.default, {
          use: "beta"
        }, _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('beta')
        })) : null, _react.default.createElement(_UITooltip.default, {
          className: "tabs-nav-bar__validation-count__tooltip",
          placement: "bottom",
          title: messagesList,
          use: "danger"
        }, _react.default.createElement("span", {
          className: "secondary-navigation__validation-count"
        }, _react.default.createElement("span", null, messagesArray.length))));
      }

      return _react.default.createElement("div", null, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey("steps." + step)
      }), ' ', step === 'targeting' ? _react.default.createElement(_UIBadge.default, {
        use: "beta"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('beta')
      })) : null);
    }
  }, {
    key: "render",
    value: function render() {
      var currentStep = this.props.currentStep;
      return _react.default.createElement(_UIToolBar.default, {
        className: "tabs-nav-bar",
        use: "tabs"
      }, _react.default.createElement(_UIToolBarGroup.default, {
        className: "tabs-nav-bar__tabs"
      }, _react.default.createElement(_UITabs.default, {
        selected: currentStep,
        onSelectedChange: this.handleStepChange
      }, this.renderTabs())));
    }
  }]);
  return TabsNavigationBar;
}(_react.PureComponent);

exports.default = TabsNavigationBar;
module.exports = exports.default;